import * as styles from "./CloseIcon.module.css";

interface IProps {
    fill?: string;
}

export const CloseIcon = (props: IProps) => {
    return (
        <svg className={styles.closeIcon} style={{fill: props.fill || "var(--colors-secondary)"}}>
            <path d="M9 2H7.512l-2.51 2.516L2.484 2 1 2.002l3.255 3.255-3.251 3.25h1.484l2.508-2.501 2.506 2.502H8.99L5.745 5.265 9 2Z" />
        </svg>
    );
};
import * as styles from "./CloseIcon.module.css";

interface IProps {
    fill?: string;
}

export const CloseIcon = (props: IProps) => {
    return (
        <svg className={styles.closeIcon} style={{fill: props.fill || "var(--colors-secondary)"}}>
            <path d="M9 2H7.512l-2.51 2.516L2.484 2 1 2.002l3.255 3.255-3.251 3.25h1.484l2.508-2.501 2.506 2.502H8.99L5.745 5.265 9 2Z" />
        </svg>
    );
};
